/**
 * Parsed from 天気いいから、散歩しましょう - Deer Memo.lrc
 * Format: [MM:SS.xx] or [M:SS.xx] -> time in seconds
 */
export const walkSongLyrics = [
  { time: 2.734, text: '因為你而喜歡上了散步' },
  { time: 4.73, text: '喜歡在你身邊 腦袋像是短路' },
  { time: 7.272, text: '喜歡在你身邊 感受這美好世界' },
  { time: 9.68, text: '跟你一起欣賞路邊花草枝葉' },
  { time: 12.782, text: '喜歡看著你的側臉安靜聽' },
  { time: 14.692, text: '著你的聲音還不夠 想錄進腦袋' },
  { time: 17.351, text: '喜歡跟你一起散步一起看星星' },
  { time: 19.668, text: '抬頭看路過 的獵戶座 他繫著腰帶' },
  { time: 22.41, text: '要再 幾天才能見 又變得更想見 你' },
  { time: 24.707, text: '就算只是吃個飯或看場電 影' },
  { time: 27.309, text: '戀夏五百日或布達佩斯大飯店' },
  { time: 29.835, text: '想從下午白日夢到你直到半夜' },
  { time: 32.546, text: '雖然不好看 的衣服需要燒掉' },
  { time: 34.99, text: '好像也需要賺 更多的鈔票' },
  { time: 37.39, text: '但想要 變得更好 只好 更努力奔跑' },
  { time: 40.243, text: '也不是不行 只需要一些抱抱' },
  { time: 42.338, text: '(now)' },
  { time: 43.163, text: '始まりは晴れ　たまに雨' },
  { time: 45.369, text: '君の甘えと笑顔　は僕の　飴' },
  { time: 48.367, text: 'ねえ　待って　もっと会おう' },
  { time: 50.454, text: '天気いいから、散歩しましょう' },
  { time: 52.841, text: '關於認識的開始該如何談起' },
  { time: 55.318, text: '起初只是一面之緣 店員 的關係' },
  { time: 57.892, text: '在某個軟體 再次滑到你' },
  { time: 60.462, text: '聊了整晚 隔天一起聽格式塔少女' },
  { time: 63.204, text: '偶爾吃宵夜 偶爾吃拉麵' },
  { time: 65.707, text: '約了聖誕夜也約了跨年夜' },
  { time: 68.104, text: '喜歡在咖啡廳或書店一起讀讀書' },
  { time: 70.168, text: '也喜歡接你下班之後一起走走路' },
  { time: 72.951, text: '因為你而喜歡上了散步' },
  { time: 75.323, text: '為了帶你出去玩再次開車上路' },
  { time: 77.937, text: '但我技術差你是否願意陪我練' },
  { time: 80.615, text: '像行動電源在身邊不怕沒有電' },
  { time: 83.203, text: '始まりは晴れ　たまに雨' },
  { time: 85.9, text: '君の甘えと笑顔　は僕の　飴' },
  { time: 88.843, text: 'ねえ　待って　もっと会おう' },
  { time: 90.892, text: '天気いいから、散歩しましょう' },
  { time: 93.494, text: '始まりは晴れ　たまに雨' },
  { time: 95.893, text: '君の甘えと笑顔　は僕の　飴' },
  { time: 99.012, text: 'ねえ　待って　もっと会おう' },
  { time: 100.951, text: '天気いいから、散歩しましょう' },
  { time: 103.495, text: '偶爾有些坦誠相見' },
  { time: 106.0, text: '偶爾有些傲慢與偏見' },
  { time: 108.642, text: '有些能調配 有些能調味' },
  { time: 111.209, text: '有些像便利商店 調酒與泡麵' },
  { time: 113.685, text: '想和你吃早餐 想和你一覺起床' },
  { time: 116.23, text: '一起看日出 再一起等到夕陽' },
  { time: 118.627, text: '想牽著你的手 走到很多好地方' },
  { time: 120.714, text: '你的每個角度都 想要拍好幾張' },
  { time: 123.36, text: '感謝你讓 我找回拍照的興趣' },
  { time: 126.227, text: '你浮誇 地誇 得讓我想要更盡力' },
  { time: 128.663, text: '如花瓣的美 構 圖沙灘perfect 又' },
  { time: 131.024, text: '挑最自然的畫 面按快門靠運氣' },
  { time: 133.897, text: '因為你而喜歡上了看海' },
  { time: 135.999, text: '喜歡在 有你的海邊 悠哉的慢慢來' },
  { time: 138.926, text: '無論晴天或陰天 今天或改天' },
  { time: 141.401, text: '希望再見 下去 不只一年半載' },
  { time: 143.995, text: '始まりは晴れ　たまに雨' },
  { time: 146.508, text: '君の甘えと笑顔　は僕の　飴' },
  { time: 149.562, text: 'ねえ　待って　もっと会おう' },
  { time: 151.672, text: '天気いいから、散歩しましょう' },
  { time: 154.135, text: '始まりは晴れ　たまに雨' },
  { time: 156.647, text: '君の甘えと笑顔　は僕の　飴' },
  { time: 159.693, text: 'ねえ　待って　もっと会おう' },
  { time: 161.645, text: '天気いいから、散歩しましょう' },
];
